import { useConfig } from '@chainlit/react-client';

import { isEmbeddedSidebar } from '@/lib/embedded-sidebar';

const useLayoutMaxWidth = () => {
    const { config } = useConfig();

    if (isEmbeddedSidebar) return '100%';

    return config?.ui.layout === 'wide'
        ? 'min(60rem, 100vw)'
        : 'min(54rem, 100vw)';
};

export { useLayoutMaxWidth };
